import styles from '@redturtle/qubicaamf-theme/components/Header/styles.module.css';
import LocalWebSiteMenu from '@redturtle/qubicaamf-theme/components/Header/LocalWebSiteMenu';
import CartSVG from '@redturtle/qubicaamf-theme/components/Icons/CartSVG';
import { defineMessages, useIntl } from 'react-intl';

export default function HeaderSlim() {
  const intl = useIntl();
  return (
    <div className={styles.headerSlim}>
      <ul>
        <li>
          <a className={styles.careers} href={`https://careers.qubicaamf.com/`}>
            {intl.formatMessage(messages.careers)}
          </a>
        </li>
        <li>
          <LocalWebSiteMenu />
        </li>
        <li>
          {/* @ts-ignore */}
          <a title="QubicaAMF eShop" href="https://eshop.qubicaamf.com/">
            <CartSVG size="M" />
          </a>
        </li>
      </ul>
    </div>
  );
}

const messages = defineMessages({
  careers: {
    id: 'careers',
    defaultMessage: 'Careers',
  },
});
